<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {useRouter} from "vue-router";

const compName = 'ReviewQueueComponent';

const router = useRouter();

const data = reactive({
  loading: false,
  hasClaims: false,
  claimId: null
});

const getData = () => {
  data.loading = true
  ApiWrapper.post('review-queue', 'get-claims', {})
  .then((response) => {
    if(response.hasClaims){
      data.hasClaims = response.hasClaims;
    }else{
      data.hasClaims = false
    }

    data.loading = false
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loading = false;
  })
}

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const assignClaim = () => {
  data.loading = true
  ApiWrapper.post('review-queue', 'assign-claim', {})
      .then((response) => {

        if(response.alreadyAssigned === true || response.message === 'Already assigned') {
          data.loading = false;
          ToastUtil.errorMsg('Already Assigned as a reviewer to an uncompleted claim');
        }
        else {
          data.claimId = response.id
          ApiWrapper.post('tasks', 'update-status', {
            claimId: response.id,
            formData: {},
            id: response.taskId
          })
              .then((response2) => {
                getData()

                ToastUtil.successMsg('Assigned claim');
                activeComponentStore.notifyComponents(['tasks','claims'],compName);


                if(response2.thirdPartyError !== null) {
                  ToastUtil.error(response2.thirdPartyError);
                }
                else if (response2.xactError === true) {
                  ToastUtil.errorMsg('Error updating task in Xact');
                }

                router.push({ path: `/claim/${data.claimId}` });
              })
              .catch((err) => {
                ToastUtil.error(err);
                data.loading = false;
              })
        }
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      });
}

onMounted(async() => {
    getData()
});

</script>

<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>Review Queue</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col v-if="data.hasClaims" class="display-3 text-center" cols="12">
<!--            {{data.hasClaims}} Claims Available-->
            Claims Available
          </v-col>
          <v-col v-else class="display-2 text-center" cols="12">
            No Claims Available
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <v-btn
                v-if="data.loading===false && data.hasClaims && Permissions.checkPermissions(['review-queue.assign']) && Permissions.checkPermissions(['tasks.update-status'])"
                @click="assignClaim"
                variant="elevated"
                color="primary"
            >
              Pull From Queue
            </v-btn>
            <v-btn v-else disabled variant="elevated" class="secondary">Pull From Queue</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped>
v-container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>